module.exports = __webpack_public_path__ + "img/news-feed-bg.4d5dc08c.svg";